module.exports = __webpack_public_path__ + "img/img (47).8668e3fe.png";